import { put, takeEvery, select } from 'redux-saga/effects'
import {
    SHOPCART_ADD_EVENT, SHOPCART_ADD_EVENT_WITH_TOURHOLD, SHOPCART_ERROR,
    SHOPCART_SET_TOUR_PRODUCT_QUANTITY_WITH_TOURHOLD_LOADING,
    SHOPCART_SET_TOUR_PRODUCT_QUANTITY,
    SHOPCART_REMOVE_TOUR_PRODUCT_WITH_TOURHOLD_LOADING,
    SHOPCART_REMOVE_TOUR_PRODUCT,
    SHOPCART_REMOVE_EVENT,
    SHOPCART_RESET_STATE_WITH_TOURHOLD_LOADING,
    SHOPCART_REMOVE_SINGLE_TOUR_WITH_TOURHOLD_LOADING,
    SHOPCART_RESET_STATE, SHOPCART_RESET_STATE_WITH_UNIQUECOUPONHOLD,
    SHOPCART_REMOVE_GIFTCARDS,
    SHOPCART_REMOVE_ALL_COUPONS,
    SHOPCART_RESET_GIFTCARDS
} from "../actions/actionShopCart";
import { postTourHold } from 'api';
import { deleteGiftCardHold } from 'api';
import { genfunction } from 'helpers'
import { deleteUniqueCouponHolds } from 'api';

async function fetchAsync(func, payload) {
    const response = await func(payload);
    if (response.status == 200) {
        return await response.json();
    }
    else if (response.status == 202 || response.status == 204) {
        return "nocontent";
    }
    else if (response.status == 400) {
        throw await response.json();
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to perform tourhold, response status: " + response.status + "\"}]}")
    }
}

function* ShopcartAddEventWithTourHold(action) {
    try {
        let tourholds = genfunction.ConvertCartItemToTourHold(action.payload.cartevent, action.payload.event, action.isEditEvent);
        let tourholdresponse = yield fetchAsync(postTourHold, tourholds);
        let bktype = yield select(state => state.reducerBookingTypes.bookingTypes);

        action.payload.event.BookingTypeTerms = bktype[0].BookingTypeTerms;

        if (tourholdresponse == "nocontent") throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to perform tourhold\"}]}"
        else {
            action.payload.event = genfunction.SetTourHoldRef(tourholdresponse, action.payload.event);

            yield put({
                type: SHOPCART_ADD_EVENT, payload: action.payload.event, organizationID: action.organizationID
                , groupSize: action.groupSize, paymentOption: action.paymentOption, amountSelected: action.amountSelected, isEditEvent: action.isEditEvent
            });

        }
    } catch (e) {
        yield put({ type: SHOPCART_ERROR, error: e.Errors[0].ErrorMessage });
    }
}


function* ShopcartSetTourProductQuantityTourHold(action) {
    try {
        let tourholds = genfunction.ConvertCartItemToTourHoldIncreaseQuantity(action.payload.CartEvent, action.payload.TourEventID, action.payload.TourProductID, action.payload.Quantity);
        let tourholdresponse = yield fetchAsync(postTourHold, tourholds);

        if (tourholdresponse == "nocontent") throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to perform tourhold\"}]}"
        else {
            yield put({ type: SHOPCART_SET_TOUR_PRODUCT_QUANTITY, payload: action.payload });
        }
    } catch (e) {
        yield put({ type: SHOPCART_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

function* ShopcartRemoveTourProductWithTourHold(action) {
    try {
        let tourholds = genfunction.ConvertCartItemToTourHoldRemoveTourProduct(action.payload.CartEvent, action.payload.TourEventID, action.payload.TourProductID);

        let tourholdresponse = yield fetchAsync(postTourHold, tourholds);
        if (tourholdresponse == "nocontent") throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to perform tourhold\"}]}"
        else {
            yield put({ type: SHOPCART_REMOVE_TOUR_PRODUCT, payload: action.payload });
        }
    } catch (e) {
        yield put({ type: SHOPCART_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

function* ShopcartResetStateWithTourHold(action) {
    try {
        let tourholds = genfunction.ConvertCartItemToTourHoldResetState(action.payload);
        let cashlessholds = yield select(state => state.reducerShopCart.cashless);
        let tourholdresponse = yield fetchAsync(postTourHold, tourholds);
        if (tourholdresponse == "nocontent") throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to perform tourhold\"}]}"
        else {
            for (let index = 0; index < cashlessholds.length; index++) {
                let cashlessholdresponse = yield fetchAsync(deleteGiftCardHold, '/?GiftcardHoldRef=' + cashlessholds[index].GiftcardHoldRef);
                if (cashlessholdresponse != "nocontent")
                    throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to delete GiftCardHold\"}]}"
            }

            yield put({ type: SHOPCART_RESET_STATE, payload: action.payload });
        }
    } catch (e) {
        yield put({ type: SHOPCART_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

function* actionShopCartRemoveSingleTourWithTourHold(action) { 
    try {
        let tourholds = genfunction.ConvertCartTourToTourHoldResetState(action.payload.CartEvent, action.payload.TourEventID);
        let tourholdresponse = yield fetchAsync(postTourHold, tourholds);
        if (tourholdresponse == "nocontent") throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to perform tourhold\"}]}"
        else {
            yield put({ type: SHOPCART_REMOVE_EVENT, payload: action.payload.TourEventID });
        }
    } catch (e) {
        yield put({ type: SHOPCART_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

function* ShopcartResetStateWithUniqueCouponHolds(action) {
    try {

        let tourCoupons = yield select(state => state.reducerShopCart.tourCoupons);

        tourCoupons = tourCoupons.filter(x => x.RequireUniqueCouponCode);

        if (tourCoupons && tourCoupons.length > 0)
            for (let index = 0; index < tourCoupons.length; index++) {
                let uniqueCouponHoldResponse = yield fetchAsync(deleteUniqueCouponHolds, '/?CouponHoldRef=' + tourCoupons[index].CouponHoldRef);
                if (uniqueCouponHoldResponse != "nocontent")
                    throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to delete UniqueCouponHolds\"}]}"
            }

        if (action.payload) {
            yield put({ type: SHOPCART_REMOVE_ALL_COUPONS, payload: action.payload });
        }
    } catch (e) {
        yield put({ type: SHOPCART_ERROR, error: e.Errors[0].ErrorMessagee });
    }
}

function* shopcartremovegiftcards(action) {
    try {
        let cashlessholds = yield select(state => state.reducerShopCart.cashless);

        for (let index = 0; index < cashlessholds.length; index++) {
            let cashlessholdresponse = yield fetchAsync(deleteGiftCardHold, '/?GiftcardHoldRef=' + cashlessholds[index].GiftcardHoldRef);
            if (cashlessholdresponse != "nocontent")
                throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to delete GiftCardHold\"}]}"
        }

        yield put({ type: SHOPCART_RESET_GIFTCARDS, payload: action.payload });

    } catch (e) {
        yield put({ type: SHOPCART_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

export const sagaShopCart = [
    takeEvery(SHOPCART_ADD_EVENT_WITH_TOURHOLD, ShopcartAddEventWithTourHold),
    takeEvery(SHOPCART_SET_TOUR_PRODUCT_QUANTITY_WITH_TOURHOLD_LOADING, ShopcartSetTourProductQuantityTourHold),
    takeEvery(SHOPCART_REMOVE_TOUR_PRODUCT_WITH_TOURHOLD_LOADING, ShopcartRemoveTourProductWithTourHold),
    takeEvery(SHOPCART_RESET_STATE_WITH_TOURHOLD_LOADING, ShopcartResetStateWithTourHold),
    takeEvery(SHOPCART_REMOVE_SINGLE_TOUR_WITH_TOURHOLD_LOADING, actionShopCartRemoveSingleTourWithTourHold),
    takeEvery(SHOPCART_RESET_STATE_WITH_UNIQUECOUPONHOLD, ShopcartResetStateWithUniqueCouponHolds),
    takeEvery(SHOPCART_REMOVE_GIFTCARDS, shopcartremovegiftcards)
];
